import axios from 'axios';

const createRequest = () => {
  let { token } = JSON.parse(sessionStorage.getItem('lendi_auth') || '{}');

  if (process.env.REACT_APP_BYPASS_AUTH === 'true' && process.env.REACT_APP_TEST_TOKEN) {
    token = process.env.REACT_APP_TEST_TOKEN;
  }

  return axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const request = createRequest();
